import api from '_config/http'
import axios from 'axios';

export function getLocation(location, limit) {

    const body = JSON.stringify({
        "locationName": location,
        "limit": limit
    });

    return api.post('/hotels/search-location', body)
        .then(response => {
            if (response.status === 200) {
               return response.data;
            }
        })
        .catch(error => console.log(error))
}

export function getLocationAirfare(location) {

    const body = JSON.stringify({
        "q": location
    });

    return axios.post(process.env.REACT_APP_FRACTAL + '/geolocation?fromChannel=tim', {
                q: location
            }, {
            headers: {
                'Content-Type': 'application/json'
            },

        })
        .then(response => {
            console.log('response', response)
            return response.data

        })
        .catch(error => console.log('error', error))
}

